import { Button } from "@gigpro/ui/Button";
import { QuantitySelector } from "components/QuantitySelector";
import React from "react";

interface SeatsForCandidatesProps {
  /** Seats the shift has open; one or none means there's nothing to choose. */
  openSeats: number;
  value: number;
  onChange: (seats: number) => void;
}

/** How many of a shift's open seats go to candidates: a line to read, with a stepper behind Change. */
export const SeatsForCandidates = ({ openSeats, value, onChange }: SeatsForCandidatesProps) => {
  const [changing, setChanging] = React.useState(false);
  if (openSeats <= 1) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-1 gap-y-2 text-small text-black">
      <span>
        {value} of {openSeats} seats for candidates
      </span>
      {changing ? (
        <QuantitySelector
          look="group"
          className="ml-1 w-28"
          value={value}
          minValue={1}
          maxValue={openSeats}
          onValueChange={onChange}
          aria-label="Seats for candidates"
        />
      ) : (
        <>
          <span aria-hidden>·</span>
          <Button variant="text" size="small" className="px-0" onClick={() => setChanging(true)}>
            Change
          </Button>
        </>
      )}
    </div>
  );
};
